import {
  RiCodeBoxLine,
  RiDoubleQuotesL,
  RiH1,
  RiH2,
  RiH3,
  RiH4,
  RiListOrdered2,
  RiListUnordered,
  RiText,
} from '@remixicon/react';

import { ICON_SIZE } from './constants';
import { TextFormattingOption } from './types';

export const textFormattingOptions: TextFormattingOption[] = [
  {
    type: 'item',
    value: 'bullet-list',
    label: 'Bullet list',
    icon: <RiListUnordered size={ICON_SIZE} />,
  },
  {
    type: 'item',
    value: 'numbered-list',
    label: 'Numbered list',
    icon: <RiListOrdered2 size={ICON_SIZE} />,
  },
  { type: 'divider' },
  {
    type: 'item',
    value: 'blockquote',
    label: 'Quote',
    icon: <RiDoubleQuotesL size={ICON_SIZE} />,
  },
  {
    type: 'item',
    value: 'code-block',
    label: 'Code block',
    icon: <RiCodeBoxLine size={ICON_SIZE} />,
  },
  { type: 'divider' },
  {
    type: 'item',
    value: 'paragraph',
    label: 'Paragraph',
    icon: <RiText size={ICON_SIZE} />,
  },
  {
    type: 'item',
    value: 'h1',
    label: 'Heading 1',
    icon: <RiH1 size={ICON_SIZE} />,
  },
  {
    type: 'item',
    value: 'h2',
    label: 'Heading 2',
    icon: <RiH2 size={ICON_SIZE} />,
  },
  {
    type: 'item',
    value: 'h3',
    label: 'Heading 3',
    icon: <RiH3 size={ICON_SIZE} />,
  },
  {
    type: 'item',
    value: 'h4',
    label: 'Heading 4',
    icon: <RiH4 size={ICON_SIZE} />,
  },
];
